export function getGrantedPolicies(
  store: { getState: () => unknown },
  selector: (state: any) => any,
): Record<string, boolean> {
  const state = store.getState();
  const authList = selector(state);
  return authList?.auth?.grantedPolicies ?? {};
}

export function hasPolicy(
  store: { getState: () => unknown },
  selector: (state: any) => any,
  policyKey: string,
): boolean {
  return Boolean(getGrantedPolicies(store, selector)[policyKey]);
}
